import { AppDrawerMenu, AppName } from '@prismamedia/one-components';
import { FC } from 'react';
import { auth } from 'utils/auth';

export const OneDrawerMenu: FC = () => {
  return <AppDrawerMenu appName={AppName.Story} disconnectUser={auth.logout} />;
};
